import { render, staticRenderFns } from "./Empleados.vue?vue&type=template&id=5ef7815c&"
import script from "./Empleados.vue?vue&type=script&lang=js&"
export * from "./Empleados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports